// https://stackoverflow.com/a/58712964
export const func = {
    // functionName: (data) => {
    //    return "something"  
    // },
    getApiJsonUrl: () => {
        var url = process.env.NODE_ENV=='development' ? 
            "/gitappdata.out.json" : "//ambiesoft.com/api/gitappdata.out.json"
        console.log("aaaaaaaaaaaaaaaaaaaa")
        return url
    }
 }